// extracted by mini-css-extract-plugin
module.exports = {"quote":"EduArticlesQuote_quote__ktPhN","slide-in-out":"EduArticlesQuote_slide-in-out__JhFGl","fade-in-out":"EduArticlesQuote_fade-in-out__TK6jn"};